/**
 * DatasetHeader - Compact dataset selector header
 * 
 * CHANGE HISTORY:
 * - 251201_0235 danielbeer: Created compact header with dropdown selector
 */

import React from 'react';
import type { Dataset } from '../types/DatasetTypes';

export interface DatasetHeaderProps {
  datasets: Dataset[];
  selectedDataset: Dataset | null;
  onSelectDataset: (id: string) => void;
  onCreateDataset: () => void;
  onImportDataset: (datasetJson: string) => void;
  onExpand?: () => void;
  isExpanded?: boolean;
}

export function DatasetHeader({
  datasets,
  selectedDataset,
  onSelectDataset,
  onCreateDataset,
  onImportDataset,
  onExpand,
  isExpanded = false
}: DatasetHeaderProps) {
  return (
    <div className="dataset-header">
      <div className="dataset-selector-row">
        <label>Dataset:</label>
        <select 
          value={selectedDataset?.id || ''} 
          onChange={(e) => onSelectDataset(e.target.value)}
          className="dataset-selector"
        >
          <option value="">Select a dataset...</option>
          
          {/* App Datasets */}
          {datasets.filter(d => !d.isUserDataset).length > 0 && (
            <optgroup label="App Datasets">
              {datasets.filter(d => !d.isUserDataset).map(d => (
                <option key={d.id} value={d.id}>
                  {d.name}
                </option>
              ))}
            </optgroup>
          )}
          
          {/* User Datasets */}
          {datasets.filter(d => d.isUserDataset).length > 0 && (
            <optgroup label="My Datasets">
              {datasets.filter(d => d.isUserDataset).map(d => (
                <option key={d.id} value={d.id}>
                  {d.name}
                </option>
              ))}
            </optgroup>
          )}
        </select>
        
        <button 
          onClick={onCreateDataset}
          className="btn btn-primary"
          title="Create new dataset"
        >
          + New Dataset
        </button>
        
        <button 
          onClick={() => {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'application/json';
            input.onchange = async (e: any) => {
              const file = e.target.files?.[0];
              if (file) {
                const text = await file.text();
                onImportDataset(text);
              }
            };
            input.click();
          }}
          className="btn btn-secondary"
          title="Import dataset"
        >
          📥 Import
        </button>
        
        {onExpand && (
          <button 
            onClick={onExpand} 
            className="btn btn-ghost"
            title={isExpanded ? 'Collapse' : 'Expand'}
          >
            {isExpanded ? '⤓ Collapse' : '⤢ Expand'}
          </button>
        )}
      </div>
    </div>
  );
}
